/* Sursa unica de adevar pentru favorite: consumatorii se aboneaza, nimeni altcineva nu citeste localStorage. */
(function () {
  'use strict';

  var KEY = 'amphr:favorites';
  var VERSION = 1;

  var subscribers = [];
  var memory = [];
  var persistent = (function () {
    try {
      var probe = '__amphr_probe__';
      window.localStorage.setItem(probe, probe);
      window.localStorage.removeItem(probe);
      return true;
    } catch (e) {
      return false;
    }
  })();

  function parse(raw) {
    if (!raw) return [];
    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return [];
    }
    if (!data || data.v !== VERSION || Object.prototype.toString.call(data.items) !== '[object Array]') {
      return [];
    }
    return data.items.filter(function (h) {
      return typeof h === 'string' && h.length > 0;
    });
  }

  function read() {
    if (!persistent) return memory.slice();
    try {
      return parse(window.localStorage.getItem(KEY));
    } catch (e) {
      persistent = false;
      return memory.slice();
    }
  }

  function write(items) {
    memory = items.slice();
    if (!persistent) return;
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ v: VERSION, items: items }));
    } catch (e) {
      persistent = false;
    }
  }

  function emit() {
    var items = read();
    subscribers.slice().forEach(function (fn) {
      try {
        fn(items.slice());
      } catch (e) {
        console.warn('[amphr-favorites] subscriber failed', e);
      }
    });
  }

  function add(handle) {
    if (!handle) return false;
    var items = read();
    var at = items.indexOf(handle);
    if (at !== -1) items.splice(at, 1);
    items.unshift(handle);
    write(items);
    emit();
    return true;
  }

  function remove(handle) {
    var items = read();
    var at = items.indexOf(handle);
    if (at === -1) return false;
    items.splice(at, 1);
    write(items);
    emit();
    return false;
  }

  window.amphrFavorites = {
    list: function () { return read(); },
    count: function () { return read().length; },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    add: add,
    remove: remove,
    toggle: function (handle) {
      return read().indexOf(handle) === -1 ? add(handle) : remove(handle);
    },
    subscribe: function (fn) {
      if (typeof fn !== 'function') return function () {};
      subscribers.push(fn);
      fn(read());
      return function () {
        var at = subscribers.indexOf(fn);
        if (at !== -1) subscribers.splice(at, 1);
      };
    }
  };

  /* Un alt tab a scris: acelasi canal ca modificarile locale, ca sa nu existe
     doua cai de actualizare pentru consumatori. e.key e null la clear(). */
  window.addEventListener('storage', function (e) {
    if (e.key !== null && e.key !== KEY) return;
    emit();
  });
})();
